import axios from 'axios';

const getUsers = (grupoId, params) => axios.get(`grupo-compras/${grupoId}/entidades/usuarios`, { params });

export default {
  getUsers,
};
